/**
 * Created by m.igrachev on 9/20/2016.
 */
import React from "react";
import PropTypes from "prop-types";

export default class ModalCancel extends React.Component {
    constructor(props) {
        super(props);

        this.enhanceChild = this.enhanceChild.bind(this);
    }

    enhanceChild() {
        let originalChild = React.Children.only(this.props.children); //We accept only one children!!!
        //TODO think of better way to pass the callback to the child!
        return React.cloneElement(originalChild, {
            onClick: this.props.onModalClose,
            events: {
                onClick: this.props.onModalClose
            }
        });
    }

    render() {
        return this.enhanceChild();
    }
}

ModalCancel.displayName = "ModalCancel";

ModalCancel.propTypes = {
    onModalClose: PropTypes.func
};
